import {Component, Input, OnInit} from '@angular/core';
import {HttpCommonService} from "../../services/http-common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NzMessageService, NzModalService, NzModalSubject} from "ng-zorro-antd";

@Component({
  selector: 'app-protocol-msg',
  templateUrl: './protocol-msg.component.html',
  styleUrls: ['./protocol-msg.component.css']
})
export class ProtocolMsgComponent implements OnInit {

  @Input() fromType = '0';// 0 电商进入，1 物流进入
  @Input() userId; // 用户Id
  @Input() userName; // // 用户名
  @Input() keyWord; // // 关键字

  checkResult = false;

  constructor(private httpService: HttpCommonService, private router: Router,
              private subject: NzModalSubject, private showMsg: NzMessageService,
              private routerInfo: ActivatedRoute) { }

  ngOnInit() {
    // 获取来源
    // if (this.routerInfo.snapshot.queryParams['fromType']) {
    //   this.fromType = this.routerInfo.snapshot.queryParams['fromType'];
    // } else { // 设置个默认值
    //   this.fromType = '0';
    // }
    // this.userId = this.routerInfo.snapshot.queryParams['userId'];
    // this.userName = this.routerInfo.snapshot.queryParams['userName'];
    // this.keyWord = this.routerInfo.snapshot.queryParams['keyWord'];
  }

  closeAlert() {
    this.httpService.post('/user/center/xhsRest/updateUserInfo',
      {userId: this.userId, userName: this.userName}).subscribe(result => {
      if (result.stateCode == '1') { // 保存成功
        // 关闭弹窗
        this.subject.destroy('onOk');
        // 跳转路由
        this.router.navigate(['/searchParent'],
          {queryParams: {userId: this.userId, userName: this.userName, keyWord: this.keyWord}});
      } else {
        this.showMsg.error('系统错误，请稍后再试！');
      }
    });




  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/protocol-msg/protocol-msg.component.ts